import ProfileSettingsForm from './ProfileSettingsForm';

export default ProfileSettingsForm;
